module.exports = __webpack_public_path__ + "img/banner_home.4575f0e1.jpg";